import { defineStore } from "pinia";
import { EquipmentHistoryRepository } from "@/repository/equipment_history_repository";
import type { ValidIdDetails } from "@/interface/history/equipment_history_interface";
import { appButtonClick } from "@/utils/analytics";
import { useEquipmentLocationStore } from "@/store/history/equipment_location_store";
import { useEquipmentSearchIdsStore } from "@/store/history/equipment_id_store";

const equipmentSearchStore = useEquipmentSearchIdsStore();
const locationStore = useEquipmentLocationStore();

export const useEquipmentHistoryStore = defineStore("useEquipmentHistoryStore", {
  state: (): {
    validIdsDetail: ValidIdDetails[];
    invalidIdDetail: string[];
    selected: number;
    isLoading: boolean;
    error: string | null;
  } => ({
    validIdsDetail: [] as ValidIdDetails[],
    invalidIdDetail: [] as string[],
    selected: 0,
    isLoading: false,
    error: null
  }),
  persist: false,
  getters: {},
  actions: {
    // Making api call for the contianer history
    async fetchEquipmentHistory(): Promise<void> {
      this.resetHistory();
      try {
        this.isLoading = true;
        const service = new EquipmentHistoryRepository();
        const history = await service.getEquipmentHistroy();
        appButtonClick(
          "Container Event History",
          "Search Results Count",
          locationStore.terminalSelected.oneStreamCode,
          {
            searchedContainerCount: equipmentSearchStore.equipmentSearchIds.length,
            validContainersCount: history.validIds.length,
            invalidContainersCount: history.invalidIds.length,
            responseCode: "200",
            ...locationStore.anayticsTerminalDetails
          }
        );
        this.validIdsDetail = history.validIds;
        this.invalidIdDetail = history.invalidIds;
        this.isLoading = false;
      } catch (e: any) {
        appButtonClick(
          "Container Event History",
          "Search Results Count",
          locationStore.terminalSelected.oneStreamCode,
          {
            searchedContainerCount: equipmentSearchStore.equipmentSearchIds.length,
            validContainersCount: 0,
            invalidContainersCount: 0,
            responseCode: e || "500",
            ...locationStore.anayticsTerminalDetails
          }
        );
        this.isLoading = false;
        this.error = e;
      }
    },

    // Updating the pagination count
    updatePaginationCount(): void {
      this.pagination = {
        ...this.pagination,
        totalPages: Math.ceil(this.equipmentWithEvent.length / this.pagination.pageSize),
        totalRecords: this.equipmentWithEvent.length,
        pageSize: 25,
        page: 1
      };
    },

    resetError(): void {
      this.error = null;
    },

    resetHistory(): void {
      this.validIdsDetail = [];
      this.invalidIdDetail = [];
      this.selected = 0;
      this.isLoading = false;
      this.error = null;
    }
  }
});
